import React from "react";
import TextField from "@material-ui/core/TextField";

import { FORM_CONFIG } from "../constants";
import cn from './index.module.scss';

export const FuneralHomeForm = ({ value, onChange, className }) => {
  return (
    <div className={className}>
      <div className={cn.title}>Funeral Home</div>
      <div className={cn.field}>
        <div className={cn.label}>ID:</div>
        <TextField
          value={value.form[FORM_CONFIG.member_funeral_home_id.key]}
          name={FORM_CONFIG.member_funeral_home_id.key}
          onChange={onChange}
          variant="outlined"
          fullWidth
        />
      </div>
      <div className={cn.field}>
        <div className={cn.label}>Name:</div>
        <TextField
          value={value.form[FORM_CONFIG.member_funeral_home_name.key]}
          name={FORM_CONFIG.member_funeral_home_name.key}
          onChange={onChange}
          variant="outlined"
          fullWidth
        />
      </div>
      <div className={cn.field}>
        <div className={cn.label}>City:</div>
        <TextField
          value={value.form[FORM_CONFIG.member_funeral_home_city.key]}
          name={FORM_CONFIG.member_funeral_home_city.key}
          onChange={onChange}
          variant="outlined"
          fullWidth
        />
      </div>
      <div className={cn.field}>
        <div className={cn.label}>State:</div>
        <TextField
          value={value.form[FORM_CONFIG.member_funeral_home_state.key]}
          name={FORM_CONFIG.member_funeral_home_state.key}
          onChange={onChange}
          variant="outlined"
          fullWidth
        />
      </div>
    </div>
  )
};
